export const PROTOCOL_VERSION = 2;

export const ROOM_CODE_MIN_LENGTH = 4;
export const ROOM_CODE_MAX_LENGTH = 12;

export const MSG_TYPES = {
  // Client -> Server
  HELLO: 'HELLO',
  CLAIM_SIDE: 'CLAIM_SIDE',
  CLAIM_SEAT: 'CLAIM_SEAT',
  START_GAME: 'START_GAME',
  SET_TYCOON_AVATAR: 'SET_TYCOON_AVATAR',
  TYCOON_ACTION: 'TYCOON_ACTION',
  JOIN_SPECTATOR: 'JOIN_SPECTATOR',
  SET_SPECTATORS: 'SET_SPECTATORS',
  MOVE: 'MOVE',
  PING: 'PING',
  LEAVE: 'LEAVE',
  RESIGN: 'RESIGN',
  OFFER_DRAW: 'OFFER_DRAW',
  RESPOND_DRAW: 'RESPOND_DRAW',
  CANCEL_DRAW: 'CANCEL_DRAW',
  REQUEST_REMATCH: 'REQUEST_REMATCH',

  // Server -> Client
  STATE: 'STATE',
  AUTH_ACCEPTED: 'AUTH_ACCEPTED',
  AUTH_REJECTED: 'AUTH_REJECTED',
  LEAVE_ACCEPTED: 'LEAVE_ACCEPTED',
  RESIGN_ACCEPTED: 'RESIGN_ACCEPTED',
  DRAW_OFFERED: 'DRAW_OFFERED',
  DRAW_RESPONSE: 'DRAW_RESPONSE',
  CLAIM_ACCEPTED: 'CLAIM_ACCEPTED',
  CLAIM_REJECTED: 'CLAIM_REJECTED',
  CLAIM_SEAT_ACCEPTED: 'CLAIM_SEAT_ACCEPTED',
  CLAIM_SEAT_REJECTED: 'CLAIM_SEAT_REJECTED',
  START_GAME_ACCEPTED: 'START_GAME_ACCEPTED',
  TYCOON_AVATAR_ACCEPTED: 'TYCOON_AVATAR_ACCEPTED',
  TYCOON_AVATAR_REJECTED: 'TYCOON_AVATAR_REJECTED',
  TYCOON_ACTION_ACCEPTED: 'TYCOON_ACTION_ACCEPTED',
  TYCOON_ACTION_REJECTED: 'TYCOON_ACTION_REJECTED',
  MOVE_ACCEPTED: 'MOVE_ACCEPTED',
  MOVE_REJECTED: 'MOVE_REJECTED',
  PRESENCE: 'PRESENCE',
  REMATCH_REQUESTED: 'REMATCH_REQUESTED',
  GAME_OVER: 'GAME_OVER',
  ERROR: 'ERROR',
  PONG: 'PONG'
};

export const ROOM_STATUS = {
  WAITING: 'waiting',
  ACTIVE: 'active',
  FINISHED: 'finished',
  ABANDONED: 'abandoned',
  CLOSED: 'closed'
};

export const SIDES = {
  CHESS_WHITE: 'w',
  CHESS_BLACK: 'b',
  XIANGQI_RED: 'w',
  XIANGQI_BLACK: 'b',
  CARO_X: 'w',
  CARO_O: 'b'
};

export function normalizeRoomCode(value) {
  return String(value || '').trim().toUpperCase().replace(/[^A-Z0-9_-]/g, '');
}

export function isValidRoomCode(value) {
  const code = normalizeRoomCode(value);
  return code.length >= ROOM_CODE_MIN_LENGTH &&
    code.length <= ROOM_CODE_MAX_LENGTH &&
    /^[A-Z0-9][A-Z0-9_-]*$/.test(code);
}

export function getRoomId(gameType, customId) {
  if (!['chess', 'xiangqi', 'caro', 'tycoon'].includes(gameType)) {
    throw new Error(`Unsupported game type: ${gameType}`);
  }
  const code = normalizeRoomCode(customId);
  if (!isValidRoomCode(code)) throw new Error('Invalid room code');
  return `room-v2-${gameType}-${code}`;
}
